import { inject, Injectable } from "@angular/core";
import { StateContext } from "@ngxs/store";
import { TableStateModel } from "../table.state.model";
import { Pagination } from "@core/models/pagination.model";
import { TableActions } from "../table.actions";
import { AuditLogService } from "@core/services/audit-log.service";


@Injectable({
  providedIn: 'root',
})
export class AuditHandler {

    constructor() {}
    auditService = inject(AuditLogService);

    handleAuditLogsLoad(ctx: StateContext<TableStateModel>, params: Pagination) {
        this.auditService.getAllAuditLogs({ ...params }).subscribe({
          next: (response) => {
            ctx.dispatch(
              new TableActions.LoadTableDataSuccess({
                tableKey: 'auditLog',
                data: response.data?.data,
                totalCount: response.data?.total_count,
              })
            );
          },
          error: (error) => {
            ctx.dispatch(
              new TableActions.LoadTableDataFailure({
                tableKey: 'auditLog',
                error: error.message,
              })
            );
          },
        });
      }

      filterAuditLogList(
        ctx: StateContext<TableStateModel>,
        action: TableActions.FilterReferralList
      ) {
        return this.auditService
          .getAllAuditLogs(undefined, action.payload.filter)
          .subscribe({
            next: (response) => {
              ctx.dispatch(
                new TableActions.LoadTableDataSuccess({
                  tableKey: 'auditLog',
                  data: response.data?.data,
                  totalCount: response.data?.total_count,
                })
              );
            },
            error: (error) => {
              ctx.dispatch(
                new TableActions.LoadTableDataFailure({
                  tableKey: 'auditLog',
                  error: error.message,
                })
              );
            },
          });
      }

     

     
}


